import {
    Button,
    Card,
    Col,
    Form,
    Input,
    Row,
    Spin,
    message,
    App,
    Select,
    Upload
} from "antd";
import {
    LeftOutlined,
    PlusOutlined,
    LoadingOutlined,
    Loading3QuartersOutlined
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import {
    EDIT_PREDEFINE_TEMPLATE,
    VIEW_PREDEFINE_TEMPLATE
} from "../../apis/apis";
import { useNavigate, useParams } from "react-router-dom";

import CulsightPageLoader from "../../components/CulsightPageLoader";
import HtmlEditorWithPreview from "../../components/HtmlEditorWithPreview";

export default function EditPreEmailTemplate() {
    const { id } = useParams();
    const { notification } = App.useApp();
    const navigate = useNavigate();
    const [form] = Form.useForm();

    const [loading, setLoading] = useState(true);

    // ---------- FORM STATES ----------
    const [name, set_name] = useState("");
    const [envelope_sender, set_envelope_sender] = useState("");
    const [subject, set_subject] = useState("");
    const [templates_images, set_templates_images] = useState("");
    const [message_value, set_message_value] = useState("");
    const [html_type, set_html_type] = useState(1);

    // ---------- ERROR STATES ----------
    const [errors, set_errors] = useState({});
    const [uploadError, setUploadError] = useState("");

    // ---------- IMAGE STATES ----------
    const [uploadImage, setUploadImage] = useState("");
    const [uploadImageFile, setUploadImageFile] = useState("");
    const [uploadLoading, setUploadLoading] = useState(false);

    // ---------- HELPERS ----------
    const getBase64 = (file, cb) => {
        const reader = new FileReader();
        reader.onload = () => cb(reader.result);
        reader.readAsDataURL(file);
    };

    const uploadBtn = (
        <button style={{ border: 0, background: "none" }} type="button">
            {uploadLoading ? (
                <Loading3QuartersOutlined />
            ) : (
                <PlusOutlined style={{ color: "#fff" }} />
            )}
            <div style={{ marginTop: 8, color: "#fff" }}>Upload</div>
        </button>
    );

    // ---------- VIEW API ----------
    useEffect(() => {
        const VIEW_API = async () => {
            const FORM_DATA = new FormData();
            FORM_DATA.append("id", atob(id));

            const res = await VIEW_PREDEFINE_TEMPLATE(FORM_DATA);
            if (res?.data?.status) {
                const data = res.data.data;
                set_name(data.name);
                set_envelope_sender(data.envelope_sender);
                set_subject(data.subject);
                set_message_value(data.message_value);
                set_html_type(data.html_type === true ? 1 : 0);
                set_templates_images(data.templates_images || "");
            }
            setLoading(false);
        };

        VIEW_API();
    }, [id]);

    // ---------- SUBMIT ----------
    const onFinish = async () => {
        setLoading(true);

        const FORM_DATA = new FormData();
        FORM_DATA.append("id", atob(id));
        FORM_DATA.append("name", name);
        FORM_DATA.append("envelope_sender", envelope_sender);
        FORM_DATA.append("subject", subject);
        FORM_DATA.append("message_value", message_value);
        FORM_DATA.append("html_type", html_type);
        FORM_DATA.append("templates_images", templates_images);

        if (uploadImageFile) {
            FORM_DATA.append("template_thumbnail", uploadImageFile);
        }

        try {
            const response = await EDIT_PREDEFINE_TEMPLATE(FORM_DATA);

            if (response?.data?.status) {
                notification.success({
                    message: "Successful",
                    description: response.data.message,
                });
                navigate("/pre-email-template");
            } else {
                setLoading(false);
                set_errors(response?.data?.errors || {});
            }
        } catch (error) {
            setLoading(false);
            message.error(
                "Server Error: " + (error?.response?.data?.message || "Unknown error")
            );
        }
    };

    const extractNameOnly = (value) => {
        return value.replace(/[<>@.]/g, "");
    };

    return (
        <div className="lms-body">
            <Card>
                <div className="lms-form">
                    <Row>
                        <Col span={12}>
                            <h2>
                                <span
                                    style={{ cursor: "pointer", marginRight: "5px" }}
                                    onClick={() => navigate("/pre-email-template")}
                                >
                                    <LeftOutlined />
                                </span>
                                Edit Email Template
                            </h2>
                        </Col>
                    </Row>

                    {loading ? (
                        <CulsightPageLoader />
                    ) : (
                        <Form
                            form={form}
                            layout="vertical"
                            autoComplete="off"
                            onFinish={onFinish}
                            validateTrigger="onSubmit"
                        >

                            {/* ========== IMAGE UPLOAD (SAME AS ADD) ========== */}
                            <Form.Item label="Upload Template Thumbnail">
                                <Upload
                                    listType="picture-card"
                                    showUploadList={false}
                                    beforeUpload={(file) => {
                                        setUploadLoading(true);

                                        const isValidType =
                                            file.type === "image/jpeg" ||
                                            file.type === "image/png" ||
                                            file.type === "image/jpg";

                                        const isValidSize = file.size <= 512 * 1024;

                                        if (!isValidType) {
                                            setUploadError("Only JPG / PNG files allowed");
                                            setUploadLoading(false);
                                            return false;
                                        }

                                        if (!isValidSize) {
                                            setUploadError("Image must be ≤ 512KB");
                                            setUploadLoading(false);
                                            return false;
                                        }

                                        const img = new Image();
                                        img.src = URL.createObjectURL(file);

                                        img.onload = () => {
                                            if (img.width === 490 && img.height === 320) {
                                                setUploadError("");
                                                setUploadImageFile(file);
                                                getBase64(file, (url) => setUploadImage(url));
                                            } else {
                                                setUploadError("Image must be exactly 490×320 px");
                                                setUploadImage("");
                                                setUploadImageFile("");
                                            }
                                            setUploadLoading(false);
                                        };

                                        return false;
                                    }}
                                >
                                    {uploadImage ? (
                                        <img
                                            src={uploadImage}
                                            alt="template"
                                            style={{ width: "100%", objectFit: "cover" }}
                                        />
                                    ) : (
                                        uploadBtn
                                    )}
                                </Upload>

                                {/* FRONTEND ERROR */}
                                {uploadError && (
                                    <span style={{ color: "red", display: "block", marginTop: 6 }}>
                                        {uploadError}
                                    </span>
                                )}


                                {/* BACKEND ERROR */}
                                {errors?.template_thumbnail && (
                                    <span style={{ color: "red", display: "block" }}>
                                        {errors.template_thumbnail}
                                    </span>
                                )}
                                <p style={{ color: "#65e7c4", marginTop: "10px" }}>Note - Thumbnail must be smaller than or equal to 512KB and must be at least 490*320 pixels.</p>

                            </Form.Item>

                            {/* ========== OTHER FIELDS ========== */}
                            <Form.Item label="Name">
                                <Input
                                    value={name}
                                    showCount
                                    onChange={(e) => set_name(e.target.value)}
                                />
                                {errors?.name && <span style={{ color: "red" }}>{errors.name}</span>}
                            </Form.Item>

                            <Form.Item label="Envelope Sender">
                                <Input
                                    value={envelope_sender}
                                    onChange={(e) =>
                                        set_envelope_sender(extractNameOnly(e.target.value))
                                    }
                                />
                                {errors?.envelope_sender && (
                                    <span style={{ color: "red" }}>{errors.envelope_sender}</span>
                                )}
                            </Form.Item>

                            <Form.Item label="Subject">
                                <Input
                                    value={subject}
                                    onChange={(e) => set_subject(e.target.value)}
                                />
                                {errors?.subject && (
                                    <span style={{ color: "red" }}>{errors.subject}</span>
                                )}
                            </Form.Item>

                            <Form.Item label="Images (Comma separated urls)">
                                <Input
                                    value={templates_images}
                                    onChange={(e) => set_templates_images(e.target.value)}
                                />
                                {errors?.templates_images && (
                                    <span style={{ color: "red" }}>{errors.templates_images}</span>
                                )}
                            </Form.Item>

                            <HtmlEditorWithPreview
                                setHtmlCode={set_message_value}
                                description="Message"
                                htmlCode={message_value}
                            />

                            <Form.Item>
                                <Button type="primary" style={{ float: "right" }} htmlType="submit">
                                    Save
                                </Button>
                            </Form.Item>

                        </Form>
                    )}
                </div>
            </Card>
        </div>
    );
}
